import moment from "moment";
const TYPE = "agenda";

const agendaModule = {
  findAll: async (dbConnection) => {
    let agendas = [];
    let todasAgendas = [];
    let dataInicial = moment().startOf("day").utc();
    let dataFinal = moment().endOf("day").utc();

    dataInicial =
      dataInicial.format("YYYY-MM-DD") +
      "T" +
      dataInicial.format("HH:mm:ss") +
      "Z";
    dataFinal =
      dataFinal.format("YYYY-MM-DD") + "T" + dataFinal.format("HH:mm:ss") + "Z";

    let q = {
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicial,
          $lte: dataFinal,
        },
      },
      limit: 50000,
    };

    let result = await dbConnection.find(q);

    q.selector.status = { $eq: "P" };
    q.selector.data["$lt"] = q.selector.data["$gte"];
    delete q.selector.data["$gte"];
    delete q.selector.data["$lte"];

    let result2 = await dbConnection.find(q);

    if (result.docs.length) {
      agendas = result.docs;
    }

    if (result2.docs.length) {
      agendas = agendas.concat(result2.docs);
    }

    if (agendas.length) {
      agendas = getAgendaDesc(agendas);

      for (let agenda of agendas) {
        agenda.horario = agenda.horario === '' ? null : agenda.horario;
        if (agenda.horario !== null) {
          agenda.data = moment(agenda.data)
            .hour(agenda.horario.split(":")[0])
            .minute(agenda.horario.split(":")[1])
            .second(0)
            .millisecond(0)
            .utc()
            .format();
        }
      }

      let agendasAtrasadasHorario = agendas.filter(
        (agenda) =>
          agenda.status === "P" && agenda.horario !== null && agenda.atrasada
      );
      let agendasAtrasadas = agendas.filter(
        (agenda) =>
          agenda.status === "P" && agenda.horario === null && agenda.atrasada
      );

      let agendasPendentesHorario = agendas.filter(
        (agenda) =>
          agenda.status === "P" && agenda.horario !== null && !agenda.atrasada
      );
      let agendasPendentes = agendas.filter(
        (agenda) =>
          agenda.status === "P" && agenda.horario === null && !agenda.atrasada
      );

      let agendasFinalizadasHorario = agendas.filter(
        (agenda) => agenda.status === "F" && agenda.horario !== null
      );
      let agendasFinalizadas = agendas.filter(
        (agenda) => agenda.status === "F" && agenda.horario === null
      );

      agendasAtrasadasHorario = ordenarAgendaData(agendasAtrasadasHorario);
      agendasPendentesHorario = ordenarAgendaData(agendasPendentesHorario);
      agendasFinalizadasHorario = ordenarAgendaData(agendasFinalizadasHorario);

      todasAgendas = agendasAtrasadasHorario.concat(agendasAtrasadas);
      todasAgendas = todasAgendas
        .concat(agendasPendentesHorario)
        .concat(agendasPendentes);
      todasAgendas = todasAgendas
        .concat(agendasFinalizadasHorario)
        .concat(agendasFinalizadas);
    }

    return todasAgendas;
  },

  findById: async (dbConnection, idAgenda) => {
    let agenda = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idAgenda },
      },
    });

    if (result.docs.length) {
      agenda = result.docs[0];
    }

    return agenda;
  },

  findByAgendaPai: async (dbConnection, idAgendaPai) => {
    let agenda = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        idAgendaPai: { $eq: idAgendaPai },
      },
      limit: 1
    });

    if (result.docs.length) {
      agenda = result.docs[0];
    }

    return agenda;
  },

  findTotalAgendas: async (dbConnection) => {
    let agendas = [];
    let agendasPendentes = 0;
    let agendasFinalizadas = 0;
    let porcentagemAgendas = 0;
    let dataInicial = moment().startOf("day").utc();
    let dataFinal = moment().endOf("day").utc();

    dataInicial = dataInicial.format("YYYY-MM-DD HH:mm:ss");
    dataFinal = dataFinal.format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicial,
          $lte: dataFinal,
        },
      },
      fields: ["status"],
      limit: 50000,
    });

    if (result.docs.length) {
      agendas = result.docs;

      agendasPendentes = agendas.filter((agenda) => agenda.status === "P")
        .length;
      agendasFinalizadas = agendas.filter((agenda) => agenda.status === "F")
        .length;

      if (agendasPendentes === 0) {
        porcentagemAgendas = 100;
      } else {
        if (agendasFinalizadas > 0) {
          porcentagemAgendas = (agendasFinalizadas * 100) / agendas.length;
        }
      }
    }

    porcentagemAgendas = parseFloat(porcentagemAgendas.toFixed(2));

    return { agendasPendentes, agendasFinalizadas, porcentagemAgendas };
  },

  findAllByPeriodo: async (dbConnection, dataInicial, dataFinal) => {
    let agendas = [];
    dataInicial = moment(dataInicial).startOf("day").utc();
    dataFinal = moment(dataFinal).endOf("day").utc();

    let dataInicialFormatada = dataInicial.format("YYYY-MM-DD HH:mm:ss");
    let dataFinalFormatada = dataFinal.format("YYYY-MM-DD HH:mm:ss");

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        data: {
          $gte: dataInicialFormatada,
          $lte: dataFinalFormatada,
        },
      },
      limit: 50000,
    });

    if (result.docs.length) {
      agendas = result.docs;

      agendas = getAgendaDesc(agendas);

      for (let agenda of agendas) {
        agenda.horario = agenda.horario === '' ? null : agenda.horario;
        if (agenda.horario !== null) {
          agenda.data = moment(agenda.data)
            .hour(agenda.horario.split(":")[0])
            .minute(agenda.horario.split(":")[1])
            .second(0)
            .millisecond(0)
            .utc()
            .format();
        }
      }
    }

    return agendas;
  },
  salvarAgenda: async (
    dbConnection,
    agenda

  ) => {
    return new Promise(async (resolve, reject) => {
      const adicionarCoordenadas = async (coordenadas) => {
        agenda.coordenadas = coordenadas
        await dbConnection.put(agenda);
      }
      if ((await "geolocation") in navigator) {
        await navigator.geolocation.getCurrentPosition(
          async function (position) {
            await adicionarCoordenadas(
              `${position.coords.latitude},${position.coords.longitude}`
            );
            resolve();
          },
          async function (error) {
            console.log(error);
            await adicionarCoordenadas(null);
            resolve();
          }
        );
      } else {
        await adicionarCoordenadas(null);
        resolve();
      }
    });
  },

  finalizarAgendaPedido: async (dbConnection, idAgenda, idPedido) => {
    let agenda = null;

    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        _id: { $eq: idAgenda },
      },
    });

    if (result.docs.length) {
      agenda = result.docs[0];

      agenda.status = "F";
      agenda.dataFinalizacao = new Date();
      agenda.finalizadoSucesso = true;
      agenda.motivoFinalizacao = null;
      agenda.idPedido = idPedido;

      await dbConnection.put(agenda);
    }
  },

};

export default agendaModule;

function ordenarAgendaData(agendas) {
  agendas = agendas.map((item) => {
    item.newDate = new Date(item.data);
    return item;
  });

  agendas = agendas.sort(function (a, b) {
    return a.newDate.getTime() - b.newDate.getTime();
  });
  return agendas;
}

function getAgendaDesc(agendas) {
  for (let agenda of agendas) {
    agenda.atrasada = false;
    let data1 = moment(agenda.data);
    let duration = moment.duration(data1.diff(moment().format("YYYY-MM-DD")));
    let diferenca = parseInt(duration.asDays());

    let dataAgenda = "";

    if (diferenca === 0) {
      let dataAgendaComparer = data1;
      dataAgendaComparer = moment(dataAgendaComparer).startOf("day");

      let dataAtual = moment().startOf("day");

      if (dataAgendaComparer.isBefore(dataAtual)) {
        dataAgenda = "Ontem";
        if (agenda.status === "P") {
          agenda.atrasada = true;
        }
      } else {
        dataAgenda = "Hoje";
      }
    } else if (diferenca === 1) {
      dataAgenda = "Amanhã";
    } else if (diferenca < 0) {
      dataAgenda = data1.format("DD/MM/YYYY");
      if(agenda.status === 'P'){
        agenda.atrasada = true;  
      }
      
    } else {
      dataAgenda = data1.format("DD/MM/YYYY");
    }

    agenda.dataAgenda = dataAgenda;
  }
  return agendas;
}
